export default {
  LOGIN: "/dang-nhap",
  HOME: "/trang-chu",
  FANPAGE: "/quan-ly-fan-page",
  CUSTOMER: "/quan-ly-khach-hang",
  SCENARIO: "/quan-ly-kich-ban",
  CAMPAIGN: "/quan-ly-chien-dich",
  TAG: "/quan-ly-tag",
  SETTING_ACCOUNT: "/quan-ly-tai-khoan",
  SYNCHRONIZE: "/dong-bo",
  INVITE: "/invite-code",
  NOTI_PERMISSION: "/noti-permisson"
};
